import React, { Fragment, useContext, useEffect, useState } from "react";
import GoBackBtn from "../../components/buttons/GoBackBtn";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import ClassCard from "../../components/classes/ClassCard";
import { postMethod } from "../../requests";
import "./schedules.css";
import ChoosePass from "../../components/passes/ChoosePass";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faExclamationCircle, faExclamationTriangle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import PaymentForPassModal from "../../components/modals/PaymentForPassModal";

const SignUpForClass = () => {
    const { t } = useTranslation();
    const { checkServerData, changeView, setAlerts, showView } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [selectedPass, setSelectedPass] = useState(null);
    const [loading, setLoading] = useState(true);
    const [alertValidation, setAlertValidation] = useState(null);
    const [showPaymentForPassModal, setShowPaymentForPassModal] = useState(null);
    const [reloadActivePasses, setReloadActivePasses] = useState(false);
    const [showReminderToChoosePass, setShowReminderToChoosePass] = useState(false);
    const [classData, setClassData] = useState(showView.params.class);

    const checkValidation = (e) => {
        e.preventDefault();
        //validation is made only on backend side
        setAlerts([{ variant: "info", message: t("info.signingUpForClass") }]);
        setBlockForm(true);
        signUpForClass();
    };

    const signUpForClass = async () => {
        const res = await postMethod("/signup-for-class", { classID: classData.class_id, upID: selectedPass });
        if (checkServerData(res)) {
            setAlerts([
                res.data.code === "noFreeSlots" || res.data.code === "cannotSignupYet" || res.data.code === "cannotSignup"
                    ? { variant: "warning", message: t(`warning.${res.data.code}`) }
                    : { variant: "success", message: t(`success.${res.data.code}`), fading: 2000, id: "signupForClass" },
            ]);
            changeView({ nav: "schedule", params: { moduleName: "APP" } });
        } else {
            setBlockForm(false);
        }
    };

    const checkIfClassIsStillValid = async () => {
        const res = await postMethod("/class-validation", { classID: classData.class_id, waitingList: false });
        if (checkServerData(res)) {
            setClassData({ ...classData, free_slots: res.data.freeSlots, cnt_waitlist: res.data.waitlist });
            if (!res.data.status) setAlertValidation({ variant: res.data.variant === "error" ? "danger" : res.data.variant, message: t(`${res.data.variant}.${res.data.code}`) });
        }
        setLoading(false);
    };

    useEffect(() => {
        checkIfClassIsStillValid();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <GoBackBtn />
            <Form onSubmit={checkValidation} autoComplete="off">
                <Container fluid="lg">
                    <Row>
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <h1 className="h5 d-inline-block m-0 pt-2">{t("schedule.signUpForClass")}</h1>
                        </Col>
                        <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                            <input type="text" name="prevent-autofill" id="prevent-autofill" style={{ display: "none" }} autoComplete="off" />
                            <Row>
                                <Col xs={12} lg={6} xxl={5} className="px-0 px-lg-2">
                                    <ClassCard c={classData} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        {loading ? (
                            <Col>
                                <p className="h6">
                                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                </p>
                            </Col>
                        ) : alertValidation ? (
                            <Alert variant={alertValidation.variant}>
                                <FontAwesomeIcon icon={alertValidation.variant === "danger" ? faExclamationCircle : faExclamationTriangle} className="me-2" />
                                {alertValidation.message}
                            </Alert>
                        ) : (
                            <>
                                {showReminderToChoosePass && (
                                    <Col xs={12}>
                                        <Alert variant="info">
                                            <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                                            {t("info.passToChooseReminder")}
                                        </Alert>
                                    </Col>
                                )}
                                <ChoosePass
                                    selectedPass={selectedPass}
                                    setSelectedPass={setSelectedPass}
                                    setFormChanged={setFormChanged}
                                    blockForm={blockForm}
                                    classID={classData.class_id}
                                    onShowPaymentForPassModal={setShowPaymentForPassModal}
                                    reloadActivePasses={reloadActivePasses}
                                    setReloadActivePasses={setReloadActivePasses}
                                />
                            </>
                        )}
                    </Row>
                    <Row className="sticky-bottom bg-light-primary">
                        <Col xs={6}>
                            <Button variant="primary" className="px-4 mt-4 mb-4" type="submit" disabled={blockForm || !formChanged}>
                                {t("signup")}
                            </Button>
                        </Col>
                        <Col xs={6} className="text-end">
                            <Button variant="outline-secondary" className="px-4 mt-4 mb-4" onClick={() => changeView({ nav: "schedule", params: { moduleName: "APP" } })}>
                                {t("cancel")}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Form>

            {showPaymentForPassModal && (
                <PaymentForPassModal
                    pass={showPaymentForPassModal}
                    onClose={() => {
                        setShowPaymentForPassModal(false);
                    }}
                    onProceed={() => {
                        setShowReminderToChoosePass(true);
                        setShowPaymentForPassModal(false);
                        setReloadActivePasses(true);
                    }}
                    signUpForClass
                />
            )}
        </Fragment>
    );
};

export default SignUpForClass;
